/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import { fetchManagementReportYearsAvailable } from '../../lib/rest/managementReportAPIClient'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../../client/js/components/LoadingHelper'
import { DateTime } from 'luxon'
import RentalReportListCard from '../management-reports/RentalReportListCard'
import { parseNumber } from '@jalik/form-parser'
import { Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'
import LeaseBreadcrumb from './LeaseBreadcrumb'
import { useRouteLoaderData } from '../../../../client/js/components/RouteLoaderData'

function LeaseRentalReportListPage () {
  const intl = useIntl()
  const params = useParams<{ id: string }>()
  const leaseId = parseInt(params.id, 10)
  const lease = useRouteLoaderData<Lease>()

  const yearsQuery = useQuery({
    enabled: leaseId > 0,
    queryKey: ['leaseRentalReportYears', leaseId],
    queryFn: () => fetchManagementReportYearsAvailable({ leaseId }),
    refetchOnWindowFocus: false
  })

  const [searchParams, setSearchParams] = useQueryParams()

  const year =
    (typeof searchParams.year === 'string' ? parseNumber(searchParams.year) : null) ||
    yearsQuery.data?.data?.[0] ||
    DateTime.now().year

  const title = [
    intl.formatMessage({
      id: 'rental_reports',
      defaultMessage: 'Rapports de location'
    }),
    year
  ].join(' ')

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <LeaseBreadcrumb
          lease={lease}
          title={title}
        />

        <LoadingHelper
          query={yearsQuery}
          render={() => (
            <RentalReportListCard
              leaseId={leaseId}
              year={year}
              onYearChange={(value) => {
                setSearchParams((s) => ({ ...s, year: String(value) }))
              }}
            />
          )}
        />
      </Container>
    </Page>
  )
}

export default LeaseRentalReportListPage
